import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const toLocal = (iso) => (iso ? new Date(iso).toISOString().slice(0, 16) : "");
const toISO = (v) => (v ? new Date(v).toISOString() : null);

export default function SaleAdmin() {
  const [s, setS] = useState({ name: "LEE BAG Sale", discount_percent: 10, start_at: "", end_at: "", active: false });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/sale").then((r) => {
    const d = r.data || {};
    setS({ name: d.name || "LEE BAG Sale", discount_percent: d.discount_percent || 10, start_at: toLocal(d.start_at), end_at: toLocal(d.end_at), active: !!d.active });
  }).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/sale", { name: s.name, discount_percent: +s.discount_percent, start_at: toISO(s.start_at), end_at: toISO(s.end_at), active: s.active });
      toast.success(s.active ? "Sale is live" : "Sale saved (not live)");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };
  const stop = async () => { await api.post("/admin/sale/stop"); toast.success("Sale stopped"); load(); };

  return (
    <div className="max-w-xl">
      <h1 className="font-serif text-3xl mb-2">Sale</h1>
      <p className="text-xs text-[#8C867D] mb-6 uppercase tracking-widest">Timed storewide discount — applies to all product prices instantly</p>
      <div className="admin-surface p-6 space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm">Sale Live</span>
          <button onClick={() => setS({ ...s, active: !s.active })} className={`w-12 h-6 rounded-full relative transition ${s.active ? "bg-[#C5A059]" : "bg-[#27272A]"}`} data-testid="sale-active-toggle">
            <span className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${s.active ? "left-7" : "left-1"}`} />
          </button>
        </div>
        <div>
          <label className="block text-[10px] uppercase tracking-widest text-[#8C867D] mb-1">Sale Name</label>
          <input value={s.name} onChange={(e) => setS({ ...s, name: e.target.value })} className="admin-input w-full" data-testid="sale-name" />
        </div>
        <div>
          <label className="block text-[10px] uppercase tracking-widest text-[#8C867D] mb-1">Discount %</label>
          <input type="number" min="1" max="90" value={s.discount_percent} onChange={(e) => setS({ ...s, discount_percent: e.target.value })} className="admin-input w-full" data-testid="sale-percent" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-[10px] uppercase tracking-widest text-[#8C867D] mb-1">Starts (optional)</label>
            <input type="datetime-local" value={s.start_at} onChange={(e) => setS({ ...s, start_at: e.target.value })} className="admin-input w-full" data-testid="sale-start" />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-widest text-[#8C867D] mb-1">Ends (optional)</label>
            <input type="datetime-local" value={s.end_at} onChange={(e) => setS({ ...s, end_at: e.target.value })} className="admin-input w-full" data-testid="sale-end" />
          </div>
        </div>
        <p className="text-xs text-[#8C867D]">Set start/end to schedule the sale. Leave empty to run until stopped manually.</p>
        <div className="flex gap-3">
          <button onClick={save} disabled={busy} className="bg-[#C5A059] text-[#121212] px-6 py-2 text-xs uppercase tracking-widest" data-testid="sale-save">{busy ? "…" : "Save / Start Sale"}</button>
          <button onClick={stop} className="border border-[#27272A] px-6 py-2 text-xs uppercase tracking-widest" data-testid="sale-stop">Stop Sale</button>
        </div>
      </div>
    </div>
  );
}
